import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { Dimmer } from "../../spinner";
import { formatoFecha } from "../../../util/varios";
import axios from "axios";
import CatalogoActividadEconomica from "../../../catalogos/catalogoActividadEconomica";
import { utils, writeFile } from "xlsx";

export const ImpSectorActiEconomica = (props) => {
  // ========== ESTADOS DEL FORMULARIO ==========
  const [buscarOpcion, setBuscarOpcion] = useState("1"); // "1": Todos, "2": Por fecha/actividad, "3": Agente (solo 101)
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [tipoContribuyente, setTipoContribuyente] = useState("PERMANENTE");
  const [anioSeleccionado, setAnioSeleccionado] = useState("");
  const [codActividad, setCodActividad] = useState("");
  const [descripcionActi, setDescripcionActi] = useState("");

  // NUEVOS ESTADOS PARA SECTOR (solo para tipo 101)
  const [sectorDesde, setSectorDesde] = useState("");
  const [sectorHasta, setSectorHasta] = useState("");

  // Checkboxes de status (solo para 101)
  const [chkActivo, setChkActivo] = useState(false);
  const [chkInactivo, setChkInactivo] = useState(false);
  const [chkClausurado, setChkClausurado] = useState(false);
  const [chkFiscal, setChkFiscal] = useState(false);
  const [chkNotificado, setChkNotificado] = useState(false);
  const [chkDepLegal, setChkDepLegal] = useState(false);
  const [chkExonerado, setChkExonerado] = useState(false);
  const [chkRevCerrado, setChkRevCerrado] = useState(false);

  // ========== ESTADOS PARA MODALES Y CONTROL ==========
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState("");
  const [msg, setMsg] = useState("");
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [titulo2, setTitulo2] = useState("");
  const [msg2, setMsg2] = useState("");
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState("");
  const [anio, setAnio] = useState([]);
  const [years, setYears] = useState("");
  const [contar1, setContar1] = useState(0);

  // ========== CONFIGURACIÓN ==========
  const op = require("../../../../src/modulos/datos");

  // ========== EFECTOS ==========
  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("post"));
    if (obj) {
      setFechaSistema(obj.fechasistema || "");
      const aini = parseInt(obj.anioactu) - 7;
      const afin = parseInt(obj.anioactu);
      const nanio = [];
      for (let i = 1; i <= afin - aini; i++) {
        nanio.push({ anio: afin + 1 - i });
      }
      setAnio(nanio);
    }
    // Inicializar fechas por defecto (primer día del año actual y hoy)
    const hoy = new Date();
    const primerDiaAnio = new Date(hoy.getFullYear(), 0, 1);
    const fechaInicio = primerDiaAnio.toISOString().split("T")[0];
    const fechaFin = hoy.toISOString().split("T")[0];
    setFechaDesde(fechaInicio);
    setFechaHasta(fechaFin);
  }, []);

  useEffect(() => {
    if (
      props.tiporep?.toString() === "103" &&
      contar1 === 0 &&
      anio.length > 0
    ) {
      const aio = anio[0].anio;
      setAnioSeleccionado(aio);
      setYears(aio);
      setContar1(1);
    }
  }, [anio, contar1, props.tiporep]);

  // ========== MANEJADORES DE CAMBIO ==========
  const handleRadioBuscar = (e) => {
    const value = e.target.value;
    setBuscarOpcion(value);

    if (value === "3" && props.tiporep?.toString() === "101") {
      const hoy = new Date();
      const primerDiaAnio = new Date(hoy.getFullYear(), 0, 1);
      setFechaDesde(primerDiaAnio.toISOString().split("T")[0]);
      setFechaHasta(hoy.toISOString().split("T")[0]);
    } else if (value === "1") {
      setFechaDesde(fechaSistema);
      setFechaHasta(fechaSistema);
    }
  };

  const handleFechaDesdeChange = (e) => setFechaDesde(e.target.value);
  const handleFechaHastaChange = (e) => setFechaHasta(e.target.value);
  const handleTipoContribuyenteChange = (e) =>
    setTipoContribuyente(e.target.value);
  const handleAnioChange = (e) => setAnioSeleccionado(e.target.value);

  // MANEJADORES PARA SECTOR
  const handleSectorDesdeChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // solo dígitos
    if (value.length > 2) value = value.slice(0, 2);
    setSectorDesde(value);
  };

  const handleSectorHastaChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 2) value = value.slice(0, 2);
    setSectorHasta(value);
  };

  const handleSectorBlur = () => {
    // Aplicar padStart(2, '0') si hay valor
    if (sectorDesde) setSectorDesde(sectorDesde.padStart(2, "0"));
    if (sectorHasta) setSectorHasta(sectorHasta.padStart(2, "0"));

    // Validar rango si ambos tienen valor
    if (sectorDesde && sectorHasta) {
      const desde = parseInt(sectorDesde, 10);
      const hasta = parseInt(sectorHasta, 10);
      if (desde > hasta) {
        setTitulo("Error");
        setMsg(
          "El Rango no es válido: el sector 'Desde' no puede ser mayor que el 'Hasta'.",
        );
        setMostrar(true);
        // Opcional: limpiar o revertir
      }
    }
  };

  const handleCheckboxChange = (setter) => (e) => setter(e.target.checked);

  // ========== FUNCIONES DE REPORTE ==========
  const handleCloseMensa = () => setMostrar(false);

  const handleCloseSi = () => {
    setMostrar1(false);
    const reporte = "ListGenxActiv";
    let condicion = "";
    if (buscarOpcion === "1") {
      condicion = `ACT.anios = ${anioSeleccionado}`;
    } else {
      condicion = `ACT.codigoactividad = '${codActividad}' AND ACT.anios = ${anioSeleccionado}`;
    }
    const sql4 = "Según la Actividad Económica y el SECTOR";
    window.open(
      `${op.reportes}/actividadeconomica?reporte=${reporte}&CONDICION=${condicion}&TIT_RGO1=&ORDEN=&TIT_ADICIONAL=${sql4}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const handleCloseNo = () => {
    setMostrar1(false);
    const reporte = "ListGenxActiv";
    let condicion = "";
    if (buscarOpcion === "1") {
      condicion = `ACT.anios = ${anioSeleccionado}`;
    } else {
      condicion = `ACT.codigoactividad = '${codActividad}' AND ACT.anios = ${anioSeleccionado}`;
    }
    const sql4 = "Según la Actividad Económica y el SECTOR";
    window.open(
      `${op.reportes}/actividadeconomica?reporte=${reporte}&CONDICION=${condicion}&TIT_RGO1=&ORDEN=&TIT_ADICIONAL=${sql4}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const handleAceptaCatalogoActi = (
    idActi,
    codciu,
    codacti,
    descrip,
    alicuo,
    mini,
  ) => {
    setMostrar2(false);
    setCodActividad(codacti);
    setDescripcionActi(descrip.trim());
  };

  const imprimirAgenteRetencion = () => {
    window.open(
      `${op.reportes}/actividadeconomica?reporte=ListComerciosRetencion`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const imprimirReporte = () => {
    if (buscarOpcion === "3" && props.tiporep?.toString() === "101") {
      imprimirAgenteRetencion();
      return;
    }

    let sigue = true;

    // Validaciones de sector (solo para 101)
    if (props.tiporep?.toString() === "101") {
      if (sectorDesde && sectorHasta) {
        const desde = parseInt(sectorDesde, 10);
        const hasta = parseInt(sectorHasta, 10);
        if (desde > hasta) {
          setTitulo("Error");
          setMsg("El sector 'Desde' no puede ser mayor que el sector 'Hasta'.");
          sigue = false;
        }
      }
      // Si quieres que sean obligatorios, descomenta:
      // else if (!sectorDesde || !sectorHasta) {
      //   setTitulo("Error");
      //   setMsg("Debe ingresar el rango de sector.");
      //   sigue = false;
      // }
    }

    if (
      props.tiporep?.toString() === "101" &&
      buscarOpcion === "2" &&
      fechaDesde.trim() === ""
    ) {
      setTitulo("Error");
      setMsg("La Fecha Desde no debe estar vacia");
      sigue = false;
    } else if (
      props.tiporep?.toString() === "101" &&
      buscarOpcion === "2" &&
      fechaHasta.trim() === ""
    ) {
      setTitulo("Error");
      setMsg("La Fecha Hasta no debe estar vacia");
      sigue = false;
    } else if (
      fechaDesde > fechaHasta &&
      (props.tiporep?.toString() === "1" || props.tiporep?.toString() === "102")
    ) {
      setTitulo("Error");
      setMsg("La fecha de inicio no puede ser superior a la fecha de fin.");
      sigue = false;
    } else if (
      props.tiporep?.toString() === "103" &&
      buscarOpcion === "2" &&
      descripcionActi === ""
    ) {
      setTitulo("Error");
      setMsg("Debe seleccionar la actividad.");
      sigue = false;
    } else if (
      props.tiporep?.toString() === "101" &&
      buscarOpcion !== "3" &&
      !chkActivo &&
      !chkInactivo &&
      !chkClausurado &&
      !chkFiscal &&
      !chkNotificado &&
      !chkDepLegal &&
      !chkExonerado &&
      !chkRevCerrado
    ) {
      setTitulo("Error");
      setMsg("Debe seleccionar un status.");
      sigue = false;
    }

    if (!sigue) {
      setMostrar(true);
      return;
    }

    // Generar reporte
    if (props.tiporep?.toString() === "101") {
      const statusArray = [];
      if (chkActivo) statusArray.push("51");
      if (chkInactivo) statusArray.push("52");
      if (chkClausurado) statusArray.push("53");
      if (chkFiscal) statusArray.push("54");
      if (chkNotificado) statusArray.push("55");
      if (chkDepLegal) statusArray.push("56");
      if (chkExonerado) statusArray.push("57");
      if (chkRevCerrado) statusArray.push("58");
      const status_cade = statusArray.join(",");

      let condicionStatus = `COM.STATUS IN (${status_cade})`;
      if (tipoContribuyente !== "TODOS") {
        condicionStatus += ` AND COM.TIPOCONTRIBUYENTE = '${tipoContribuyente}'`;
      }

      let condicionFecha = " AND true";
      if (buscarOpcion === "2") {
        condicionFecha = ` AND COM.fechainscripcion BETWEEN '${fechaDesde}' AND '${fechaHasta}'`;
      }

      if (sectorDesde && sectorHasta) {
        condicionFecha += ` AND COM.sectorcatastral BETWEEN '${sectorDesde}' AND '${sectorHasta}'`;
      }

      const condicion = condicionStatus + condicionFecha;
      const sql4 = `CONTRIBUYENTES ${tipoContribuyente}`;

      window.open(
        `${op.reportes}/actividadeconomica?reporte=ListGenComercio&CONDICION=${condicion}&TIT_RGO1=&ORDEN=&TIT_ADICIONAL=${sql4}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } else if (props.tiporep?.toString() === "102") {
      let condicion = "true";
      let tituloPeriodo = "";
      if (buscarOpcion === "2") {
        condicion = `fechaemision BETWEEN '${fechaDesde}' AND '${fechaHasta}'`;
        tituloPeriodo = `DESDE EL ${fechaDesde} HASTA EL ${fechaHasta}`;
      }
      window.open(
        `${op.reportes}/actividadeconomica?reporte=ListGenLicenciaComercio&CONDICION=${condicion}&TIT_RGO1=${tituloPeriodo}&ORDEN=&TIT_ADICIONAL=${tituloPeriodo}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } else if (props.tiporep?.toString() === "103") {
      setTitulo2("Información");
      setMsg2("Desea abrir el reporte en formato PDF?");
      setMostrar1(true);
    }
  };

  const imprimirExcel = async () => {
    if (buscarOpcion === "3") {
      setTitulo("Información");
      setMsg("La opción de Excel no está disponible para Agente de Retención.");
      setMostrar(true);
      return;
    }

    if (
      !chkActivo &&
      !chkInactivo &&
      !chkClausurado &&
      !chkFiscal &&
      !chkNotificado &&
      !chkDepLegal &&
      !chkExonerado &&
      !chkRevCerrado
    ) {
      setTitulo("Error");
      setMsg("Debe seleccionar un status.");
      setMostrar(true);
      return;
    }
    if (buscarOpcion === "2" && fechaDesde.trim() === "") {
      setTitulo("Error");
      setMsg("La Fecha Desde no debe estar vacia");
      setMostrar(true);
      return;
    }
    if (buscarOpcion === "2" && fechaHasta.trim() === "") {
      setTitulo("Error");
      setMsg("La Fecha Hasta no debe estar vacia");
      setMostrar(true);
      return;
    }

    setActivate(true);
    try {
      const statusArray = [];
      if (chkActivo) statusArray.push("51");
      if (chkInactivo) statusArray.push("52");
      if (chkClausurado) statusArray.push("53");
      if (chkFiscal) statusArray.push("54");
      if (chkNotificado) statusArray.push("55");
      if (chkDepLegal) statusArray.push("56");
      if (chkExonerado) statusArray.push("57");
      if (chkRevCerrado) statusArray.push("58");
      const status_cade = statusArray.join(",");

      let condicionStatus = `COM.STATUS IN (${status_cade})`;
      if (tipoContribuyente !== "TODOS") {
        condicionStatus += ` AND COM.TIPOCONTRIBUYENTE = '${tipoContribuyente}'`;
      }

      let condicionFecha = " AND true";
      if (buscarOpcion === "2") {
        condicionFecha = ` AND COM.fechainscripcion BETWEEN '${fechaDesde}' AND '${fechaHasta}'`;
      }

      if (sectorDesde && sectorHasta) {
        condicionFecha += ` AND COM.sectorcatastral '${sectorDesde}' AND '${sectorHasta}'`;
      }

      const condicion = condicionStatus + condicionFecha;
      const campos = `
        IdComercio AS CODIGO,
        Rif,
        Nombre,
        direccion,
        trim(ACT.Descripcion) AS "Actividad Principal",
        TO_CHAR(FechaInscripcion, 'DD/MM/YYYY') AS "Fecha Inscripción"
      `;
      const nomtab = `Comercio AS COM
        LEFT JOIN Actividad AS ACT ON COM.IdActividad=ACT.IdActividad
        WHERE ${condicion}
      `;
      const orden = "COM.Idcomercio";
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

      const response = await axios.get(endpoint);
      const worksheet = utils.json_to_sheet(response.data);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, "SinDeclarar");
      writeFile(
        workbook,
        `ComerciosSinDeclarar-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`,
      );
    } catch (error) {
      setTitulo("Error");
      setMsg("Error al Generar el Excel");
      setMostrar(true);
    } finally {
      setActivate(false);
    }
  };

  const cancelar = () => {
    setSectorDesde("");
    setSectorHasta("");
    setChkActivo(false);
    setChkInactivo(false);
    setChkClausurado(false);
    setChkFiscal(false);
    setChkNotificado(false);
    setChkDepLegal(false);
    chkExonerado(false);
    setChkRevCerrado(false);
  };

  const salir = (e) => {
    e.preventDefault();
    props.onHideCancela();
  };

  // ========== RENDER ==========
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => setContar1(0)}
    >
      <Modal.Header className="azulGradiant">
        {props.titulo1}
        <button
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo2}
          mensaje={msg2}
          show={mostrar1}
          onHideSi={handleCloseSi}
          onHideNo={handleCloseNo}
        />
        <Dimmer active={activate} inverted />

        <CatalogoActividadEconomica
          show={mostrar2}
          onHideCancelaCatActi={() => setMostrar2(false)}
          onHideAceptaCatActi={handleAceptaCatalogoActi}
          anio={years}
        />

        <div>
          <fieldset className="row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
            <legend className="float-none w-auto">{props.titulo2}</legend>

            {/* === CAMPOS DE SECTOR (solo para tipo 101) === */}
            {props.tiporep?.toString() === "101" && (
              <div className="row col-md-12 d-flex justify-content-between mx-auto px-0">
                <div className="input-group input-group-sm mb-3 col-md-5">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Desde Sector Cobranza Nº:
                  </span>
                  <input
                    type="text"
                    autoComplete="off"
                    maxLength={2}
                    className="text-right form-control form-control-sm"
                    id="inputSectorDesde"
                    value={sectorDesde}
                    onChange={handleSectorDesdeChange}
                    onBlur={handleSectorBlur}
                    aria-label="Sector desde"
                  />
                </div>
                <div className="input-group input-group-sm mb-3 col-md-5">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Hasta Sector Cobranza Nº:
                  </span>
                  <input
                    type="text"
                    autoComplete="off"
                    maxLength={2}
                    className="text-right form-control form-control-sm"
                    id="inputSectorHasta"
                    value={sectorHasta}
                    onChange={handleSectorHastaChange}
                    onBlur={handleSectorBlur}
                    aria-label="Sector hasta"
                  />
                </div>
              </div>
            )}

            {/* Grupo de radios */}
            <div className="col-md-12 mx-auto row px-0">
              <label className="col" htmlFor="inputDireccion">
                {props.tiporep?.toString() === "101"
                  ? "Buscar por Fecha de Inscripción"
                  : props.tiporep?.toString() === "102"
                    ? "Buscar por Fecha de Impresión"
                    : props.tiporep?.toString() === "103"
                      ? "Buscar por Código de Actividad"
                      : ""}
              </label>

              <div className="form-check col-md-2">
                <input
                  className="form-check-input my-auto"
                  type="radio"
                  name="buscar"
                  value="1"
                  id="radioTodos"
                  checked={buscarOpcion === "1"}
                  onChange={handleRadioBuscar}
                />
                <label
                  className="form-check-label my-auto"
                  htmlFor="radioTodos"
                >
                  Todos
                </label>
              </div>

              <div className="form-check col-md-3">
                <input
                  className="form-check-input my-auto"
                  type="radio"
                  name="buscar"
                  value="2"
                  id="radioPorFecha"
                  checked={buscarOpcion === "2"}
                  onChange={handleRadioBuscar}
                />
                <label
                  className="form-check-label my-auto"
                  htmlFor="radioPorFecha"
                >
                  {props.tiporep?.toString() === "103"
                    ? "Por Actividad"
                    : props.tiporep?.toString() === "101"
                      ? "Por Fecha de Inscripción"
                      : "Por Fecha"}
                </label>
              </div>

              {props.tiporep?.toString() === "101" && (
                <div className="form-check col-md-3">
                  <input
                    className="form-check-input my-auto"
                    type="radio"
                    name="buscar"
                    value="3"
                    id="radioAgente"
                    checked={buscarOpcion === "3"}
                    onChange={handleRadioBuscar}
                  />
                  <label
                    className="form-check-label my-auto"
                    htmlFor="radioAgente"
                  >
                    Agente de Retención
                  </label>
                </div>
              )}
            </div>

            {/* Fechas */}
            {props.tiporep?.toString() !== "103" && (
              <div
                className="row col-md-8 mx-auto py-2"
                style={{
                  visibility:
                    buscarOpcion === "2" || buscarOpcion === "3"
                      ? "visible"
                      : "collapse",
                }}
              >
                <div className="input-group input-group-sm mb-2 col-md-6">
                  <span className="input-group-text">Desde:</span>
                  <input
                    type="date"
                    className="form-control"
                    value={fechaDesde}
                    onChange={handleFechaDesdeChange}
                    id="inputFechaDesde"
                  />
                </div>
                <div className="input-group input-group-sm mb-2 col-md-6">
                  <span className="input-group-text">Hasta:</span>
                  <input
                    type="date"
                    className="form-control"
                    value={fechaHasta}
                    onChange={handleFechaHastaChange}
                    id="inputFechaHasta"
                  />
                </div>
              </div>
            )}

            {/* Año (solo para 103) */}
            {props.tiporep?.toString() === "103" && (
              <div className="row col-md-12 mx-auto">
                <div className="input-group input-group-sm mb-2 col-md-4 mx-auto">
                  <span className="input-group-text">Año:</span>
                  <select
                    className="form-select form-select-sm"
                    value={anioSeleccionado}
                    onChange={handleAnioChange}
                  >
                    {anio.map((a) => (
                      <option key={a.anio} value={a.anio}>
                        {a.anio}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            {/* Actividad (solo para 103) */}
            {props.tiporep?.toString() === "103" && (
              <div
                className="row col-md-12 mx-auto px-0"
                style={{
                  visibility: buscarOpcion === "2" ? "visible" : "collapse",
                }}
              >
                <div className="input-group input-group-sm mb-2 col-md-5">
                  <span className="input-group-text">Código Actividad:</span>
                  <input
                    type="text"
                    disabled
                    value={codActividad}
                    className="form-control form-control-sm"
                  />
                  <button
                    onClick={() => setMostrar2(true)}
                    className="btn btn-sm btn-info"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
                <div className="col-md-7"></div>
                <div className="input-group input-group-sm mb-2 col-md-12">
                  <span className="input-group-text">Descripción:</span>
                  <textarea
                    disabled
                    style={{ height: 70 }}
                    value={descripcionActi}
                    className="form-control form-control-sm"
                  />
                </div>
              </div>
            )}

            {/* Tipo de contribuyente (solo 101 y solo si NO es agente) */}
            {props.tiporep?.toString() === "101" && buscarOpcion !== "3" && (
              <div className="row col-md-12 mx-auto">
                <div className="input-group input-group-sm mb-2 col-md-6">
                  <span className="input-group-text">
                    Tipo de Contribuyente:
                  </span>
                  <select
                    className="form-select form-select-sm"
                    value={tipoContribuyente}
                    onChange={handleTipoContribuyenteChange}
                  >
                    <option value="PERMANENTE">PERMANENTE</option>
                    <option value="TRANSEUNTE">TRANSEUNTE</option>
                    <option value="EVENTUAL O AMBULANTE">
                      EVENTUAL O AMBULANTE
                    </option>
                    <option value="IRREGULAR">IRREGULAR</option>
                    <option value="REVISADO/CERRADO">REVISADO/CERRADO</option>
                    <option value="EMPRENDIMIENTO">EMPRENDIMIENTO</option>
                    <option value="TODOS">TODOS</option>
                  </select>
                </div>
              </div>
            )}

            {/* Checkboxes de status (solo 101 y solo si NO es agente) */}
            {props.tiporep?.toString() === "101" && buscarOpcion !== "3" && (
              <div
                className="row col-md-12 mx-auto"
                style={{ marginBottom: "20px" }}
              >
                <div className="col-md-12 mx-auto border-azul row rounded py-2">
                  <div className="form-check col-md-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={chkActivo}
                      onChange={handleCheckboxChange(setChkActivo)}
                    />
                    <label className="form-check-label">Activo</label>
                  </div>
                  <div className="form-check col-md-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={chkInactivo}
                      onChange={handleCheckboxChange(setChkInactivo)}
                    />
                    <label className="form-check-label">Inactivo</label>
                  </div>
                  <div className="form-check col-md-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={chkClausurado}
                      onChange={handleCheckboxChange(setChkClausurado)}
                    />
                    <label className="form-check-label">Clausurado</label>
                  </div>
                  <div className="form-check col-md-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={chkFiscal}
                      onChange={handleCheckboxChange(setChkFiscal)}
                    />
                    <label className="form-check-label">Fiscal</label>
                  </div>
                  <div className="form-check col-md-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={chkNotificado}
                      onChange={handleCheckboxChange(setChkNotificado)}
                    />
                    <label className="form-check-label">Notificado</label>
                  </div>
                  <div className="form-check col-md-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={chkDepLegal}
                      onChange={handleCheckboxChange(setChkDepLegal)}
                    />
                    <label className="form-check-label">Dep. Legal</label>
                  </div>
                  <div className="form-check col-md-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={chkExonerado}
                      onChange={handleCheckboxChange(setChkExonerado)}
                    />
                    <label className="form-check-label">Exonerado</label>
                  </div>
                  <div className="form-check col-md-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={chkRevCerrado}
                      onChange={handleCheckboxChange(setChkRevCerrado)}
                    />
                    <label className="form-check-label">Rev/Cerrado</label>
                  </div>
                </div>
              </div>
            )}
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {props.tiporep?.toString() === "101" && buscarOpcion !== "3" && (
          <button
            onClick={imprimirExcel}
            className="btn btn-sm btn-info rounded-pill col-md-2"
          >
            <i className="fas fa-file-pdf"> Excel</i>
          </button>
        )}
        <button
          onClick={imprimirReporte}
          className="btn btn-sm btn-primary rounded-pill col-md-2"
        >
          <i className="fas fa-print"> Imprimir</i>
        </button>
        <button
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
        <button
          onClick={salir}
          className="btn btn-sm btn-danger rounded-pill col-md-2"
        >
          <i className="fa fa-sign-out"> Salir</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
